// extracted by mini-css-extract-plugin
module.exports = {"languageSelect":"LanguageSelector_languageSelect__3Ij3D","languageIcon":"LanguageSelector_languageIcon__2FCb9"};